import React, { forwardRef } from 'react';
import { Card } from 'react-bootstrap';

const Termination = forwardRef((props, ref) => {
 return (
  <Card className="mb-3" id="termination" ref={ref}>
   <Card.Header className="bg-light">
    <h5 className="mb-0">Terminacion</h5>
   </Card.Header>
   <Card.Body>
    <p className="mb-0 ps-3">
     Se puede rescindir este acuerdo por notificación escrita por cualquiera de las partes en caso de incumplimiento material o si
     la otra parte se convierte en objeto de un proceso de insolvencia o quiebra.
    </p>
   </Card.Body>
  </Card>
 );
});

export default Termination;
